// directives/copy.js
import Clipboard from 'clipboard'
import { Toast } from 'vant';
import i18n from '../../i18n';

export default {
  bind(el, binding) {
    const clipboard = new Clipboard(el, {
      text: () => binding.value
    })

    clipboard.on('success', () => {
    //   binding.instance.$message.success('复制成功')
        // this.$notify(this.$t('text.inputNo'))
        Toast(i18n.t('text.copySuccess'))
    })

    clipboard.on('error', () => {
        Toast(i18n.t('text.copyFail'))
    })

    el._clipboard = clipboard
  },
  unbind(el) {
    el._clipboard.destroy()
  }
}